import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function InitialSetup() {
    return (
        <section className="space-y-10">

            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold mb-2">Initial Setup</h1>
                <p className="text-slate-600">
                    Initial setup prepares EventFlow for daily operations by configuring
                    business rules, system defaults, and security settings.
                </p>
            </section>

            <section className="bg-white border-l border-[#C9A24E] p-8 rounded-lg">
                <h2 className="text-lg font-semibold mb-3">Overview</h2>
                <p className="text-slate-600 text-sm">
                    Correct initial configuration ensures accurate bookings, financial
                    calculations, and smooth system behavior.
                </p>
            </section>

            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">System Configuration</h3>
                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Timezone setup for correct dates</li>
                    <li>Currency configuration</li>
                    <li>Sales & withholding tax percentages</li>
                    <li>Production mode activation</li>
                </ul>
            </section>

            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Administrator Access</h3>
                <p className="text-slate-600">
                    Ensure admin credentials are protected and only authorized staff
                    have system-wide permissions.
                </p>
            </section>

            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Initial Master Data</h3>
                <p className="text-slate-600">
                    Configure portions, services, occasions, and system defaults before
                    starting real bookings to avoid data inconsistency.
                </p>
            </section>

            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, proceed to{" "}
                    <Link to="/docs/first-event-booking" className="font-medium text-[#C9A24E]">
                        First Event Booking
                    </Link>.
                </p>
            </section> */}
<DocNavigation
                previous={{
                    title: "Installation",
                    link: "/docs/installation"
                }}
                next={{
                    title: "First Event Booking",
                    link: "/docs/first-event-booking"
                }}
            />
        </section>
    );
}
